import { createRouter, type RouterHistory } from "@tanstack/react-router";

import { routeTree } from "../routeTree.gen";
import type { AppContext } from "./context";

export function createAppRouter(context: AppContext, history?: RouterHistory) {
  return createRouter({
    routeTree,
    context,
    defaultPreload: "intent",
    scrollRestoration: true,
    ...(history === undefined ? {} : { history }),
  });
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
